<textarea  #ta [(ngModel)]="comment"></textarea>
<!-- [ngModel]="comment" (ngModelChange)= "commentChanged($event)" -->
<button mat-raised-button class="button" color="warn" (click)="updateComment()" [class.loading]="savingComment" [disabled]="savingComment"><span>Save Comment</span></button>
